export var Colors;
(function (Colors) {
    Colors["Primary"] = "#0064C1";
})(Colors || (Colors = {}));
//# sourceMappingURL=Colors.js.map